import { BedtimePair, StoredBedtimeContext } from './bedtimeContextModel';

export const BEDTIME_CONTEXT_STORAGE_PREFIX = 'luma:bedtime-context:v1:';

export function bedtimeContextStorageKey(userId: string): string {
  return `${BEDTIME_CONTEXT_STORAGE_PREFIX}${userId}`;
}

export function readBedtimeContext(userId: string): StoredBedtimeContext | null {
  try {
    const raw = localStorage.getItem(bedtimeContextStorageKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredBedtimeContext;
    if (!parsed || parsed.version !== 1 || typeof parsed.householdId !== 'string' || typeof parsed.listenerId !== 'string' || typeof parsed.voiceId !== 'string' || typeof parsed.updatedAt !== 'string') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeBedtimeContext(userId: string, pair: BedtimePair): StoredBedtimeContext {
  const record: StoredBedtimeContext = {
    version: 1,
    ...pair,
    updatedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(bedtimeContextStorageKey(userId), JSON.stringify(record));
  } catch {
    // Private browsing/storage-full is non-fatal; the in-memory provider is
    // still authoritative for this page session.
  }
  return record;
}

export function clearBedtimeContext(userId: string): void {
  try { localStorage.removeItem(bedtimeContextStorageKey(userId)); } catch { /* no-op */ }
}
